import { Flex, FlexProps, Text } from '@chakra-ui/react';
import { Maybe } from 'api/generated/graphql';
import { IconMedal, IconProfile, IconTrophyFilled } from 'icons';
import { formatOrdinal } from 'utils/helpers';

interface GridCardHeaderProps extends FlexProps {
  gridPosition: Maybe<number> | undefined;
  ownCar: boolean;
  gridType: 'entries' | 'results';
  showAllResults?: boolean;
  runnerUp?: boolean;
}

const GridCardHeader = ({ gridPosition, ownCar, gridType, showAllResults, runnerUp, ...props }: GridCardHeaderProps) => {
  return (
    <Flex
      background={!showAllResults ?
        "linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 70%)"
        : gridPosition === 1 
        ? "linear-gradient(180deg, rgba(255, 221, 86, 0.2) 0%, rgba(255, 221, 86, 0) 55%)" 
        : ownCar ? "linear-gradient(180deg, rgba(38, 166, 154, 0.2) 0%, rgba(38, 166, 154, 0) 55%)"
        : "linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 70%)"
      }
      w="full"
      position="relative"
      borderBottom="none"
      alignItems="center"
      justifyContent="center"
      p="2"
      borderTopRadius="8px"
      gap="1"
      _before={{
        content: '""',
        position: 'absolute',
        inset: 0,
        borderTopRadius: '8px',
        padding: '1.5px',
        paddingBottom: '0px',
        background: !showAllResults ?
          "linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 70%)"
          : gridPosition === 1 
          ? "linear-gradient(180deg, rgba(255, 221, 86, 0.4) 0%, rgba(255, 221, 86, 0) 100%)"
          : ownCar 
            ? "linear-gradient(180deg, #26A69A 0%, rgba(38, 166, 154, 0) 100%)"
            : "linear-gradient(180deg, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0) 100%)",
        mask: "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
        maskComposite: "exclude"
      }}
    >
      {showAllResults && (
        ownCar && (
          <Text 
          fontSize="16px"
          lineHeight="16px"
          color="white.95"
          fontWeight="600"
          mr="1"
        >
          MY CAR
        </Text>
        )
      )}
      <Text
        fontSize="24px"
        lineHeight="24px"
        fontWeight="600"
        color={!showAllResults ? "white.95" : gridPosition === 1 ? "rgba(255, 221, 86, 1)" : ownCar ? "rgba(0, 255, 255, 1)" : "white.95"}
      >
        {gridPosition ? formatOrdinal(gridPosition) : ''}
      </Text>
    </Flex>
  );
};

export default GridCardHeader;